<div class="container-fluid pt-5" style="width: 100%">
  @for (comment of comments; track comment; let index = $index) {
    <div class="row">
      <div class="col">
        <div class="d-flex">
          <div class="p-2"><blockquote> <span style="color: var(--navy-600);">{{comment.user}}</span> - <small>{{comment.createDate | date: 'dd/MM/yy HH:mm'}}</small></blockquote></div>
          @if (comment.user === user?.username) {
            <div class="ms-auto p-2">
              <button type="button" class="btn btn-outline-danger" (click)="openModal(template, comment.key)">{{'CONTROL-MODULE.DELETE' | translate}}</button>
            </div>
          }
        </div>
        <h6>{{comment.text}}</h6>
        @if (comment.recipients) {
          <div class="p-2"><blockquote> {{'CONTROL-MODULE.RECIPIENTS' | translate}}
            @for (recipient of comment.recipients; track recipient) {
              <span class="comment-recipient"> {{recipient}}</span>
            }
          </blockquote></div>
        }
        <hr />
      </div>
    </div>
  }
  <form (ngSubmit)="onSubmit()">
    <div class="form-group mb-2" style="width: 30%;">
      <ntr-multiple-select #usersListSelect [items]="userList" [key]="'username'"
        [placeholder]="'CONTROL-MODULE.USERS_COMMENT' | translate"
      [display]="'username'"></ntr-multiple-select>
    </div>
    <div class="form-group mb-2">
      <textarea class="form-control" id="comment" rows="3" [(ngModel)]="comment" name="comment"></textarea>
    </div>
    <button type="submit" class="btn btn-primary" [disabled]="!comment">{{'CONTROL-MODULE.ADD_COMMENT' | translate}}</button>
  </form>


  <ng-template #template>
    <div class="modal-body text-center">
      <p>{{'CONTROL-MODULE.SURE_TO_DELETE_COMMENT' | translate}}</p>
      <button type="button" class="btn btn-outline-secondary" (click)="confirm()" >{{'CONTROL-MODULE.YES' | translate}}</button>
      <button type="button" class="btn btn-primary" (click)="modalRef?.hide()" >{{'CONTROL-MODULE.CANCEL' | translate}}</button>
    </div>
  </ng-template>


</div>
